import React, { useState } from "react";
import { useApi } from "../services/ApiService";
import { Trans, useTranslation } from "react-i18next";

import DownloadButton from "../components/DownloadButton.jsx";
import PageLayout from "../components/PageLayout.jsx";
import SvgIcon from "../components/SvgIcon.jsx";
import Carousel from "../components/Carousel.jsx";
import { proofCarousel } from "../main.jsx";

export default function Resources() {
  const { t } = useTranslation();
  const [error, setError] = useState(false);
  const api = useApi();

  const fileDownload = async (fileName) => {
    try {
      setError(false);
      // get new signed s3 urls from backend
      const response = await api.resourcesDownload(fileName);
      if (response.success) {
        if (response?.data?.url) {
          const url = new URL(response.data.url);
          // Create a link to trigger a file download
          const link = document.createElement("a");
          link.href = url.toString();
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          console.error("Resource not found:", fileName);
          setError(true);
        }
      }
    } catch (error) {
      console.error("Error fetching resources for download:", error);
      setError(true);
    }
  };

  return (
    <PageLayout title="Resources">
      <h1 className="mb-2">{t("resources.title")}</h1>
      <p className="text-secondary">{t("resources.description.0")}</p>
      <p className="text-secondary my-4">{t("resources.description.1")}</p>
      <p className="text-secondary my-4">{t("resources.videoTitle")}</p>
      <div className="mx-auto mt-4 divide-gray-100 rounded-md border border-gray-200 p-4">
        <span className="truncate font-medium">{t("resources.introVideo")}</span>
        <Carousel items={proofCarousel}/>
      </div>
      <p className="text-secondary my-4">{t("resources.fileTitle")}</p>
      <ul className="mx-auto mt-4 divide-y divide-gray-100 rounded-md border border-gray-200">
        <li className="flex items-center justify-between py-4 pr-5 pl-4 leading-6">
          <div className="flex w-0 flex-1 items-center">
            <SvgIcon type="attachment" />
            <div className="ml-4 flex min-w-0 flex-1 flex-col gap-1">
              <span className="truncate font-medium">{t("resources.manualButton")}</span>
              <span className="truncate text-sm font-light">{t("resources.manualDescription")}</span>
            </div>
          </div>
          <div className="div ml-4 flex shrink-0 gap-4">
            <DownloadButton file="PROOF-Manual.pdf" onClick={fileDownload}>
              {t("English")}
            </DownloadButton>
            <DownloadButton file="PROOF-Manual-Español.pdf" onClick={fileDownload}>
              {t("Español")}
            </DownloadButton>
          </div>
        </li>
        <li className="flex items-center justify-between py-4 pr-5 pl-4 leading-6">
          <div className="flex w-0 flex-1 items-center">
            <SvgIcon type="attachment" />
            <div className="ml-4 flex min-w-0 flex-1 flex-col gap-1">
              <span className="truncate font-medium">{t("resources.reflectionButton")}</span>
              <span className="truncate text-sm font-light">{t("resources.reflectionDescription")}</span>
            </div>
          </div>
          <div className="div ml-4 flex shrink-0 gap-4">
            <DownloadButton file="PROOF-RecordAndReflectionSheet.pdf" onClick={fileDownload}>
              {t("English")}
            </DownloadButton>
            <DownloadButton file="PROOF-RecordAndReflectionSheet-Español.pdf" onClick={fileDownload}>
              {t("Español")}
            </DownloadButton>
          </div>
        </li>
        <li className="flex items-center justify-between py-4 pr-5 pl-4 leading-6">
          <div className="flex w-0 flex-1 items-center">
            <SvgIcon type="attachment" />
            <div className="ml-4 flex min-w-0 flex-1 flex-col gap-1">
              <span className="truncate font-medium">{t("resources.domainButton")}</span>
              <span className="truncate text-sm font-light">{t("resources.domainDescription")}</span>
            </div>
          </div>
          <div className="div ml-4 flex shrink-0 gap-4">
            <DownloadButton file="PROOF-DomainDescriptors.pdf" onClick={fileDownload}>
              {t("English")}
            </DownloadButton>
            <DownloadButton file="PROOF-DomainDescriptors-Español.pdf" onClick={fileDownload}>
              {t("Español")}
            </DownloadButton>
          </div>
        </li>
      </ul>
      {error && (
        <div className="mt-2 text-center text-sm text-red-800">
          <Trans i18nKey="resources.downloadError">
            An error occurred please{" "}
            <a className="font-medium underline hover:opacity-50" href="/resources">
              reload the page
            </a>{" "}
            and try again
          </Trans>
        </div>
      )}
      <p className="text-secondary my-4">{t("resources.description.2")}</p>
      <p className="text-secondary my-4">{t("resources.description.3")}</p>
      <p className="text-secondary my-4">
        <Trans i18nKey="resources.description.4">
          If you are interested in utilising the PROOF framework but feel that you need further training or explanation,
          please{" "}
          <a className="font-medium underline hover:opacity-50" href="/contact">
            contact the authors
          </a>{" "}
          to request a supervision session.
        </Trans>
      </p>
      <p className="text-secondary my-4">{t("resources.description.5")}</p>
    </PageLayout>
  );
}
